import { ReactNode, useState } from "react";
import styled from "styled-components";
import Icon from "app/components/shared/Icon";

const NoticeContainer = styled.div<{ color: string }>`
  border-color: ${(props) => props.color};
  overflow: hidden;
`;

const NoticeBorderBar = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  flex: 0 0 3px;
`;

const NoticeHeading = styled.h3`
  font-size: 16px;
`;

const DismissButton = styled.button`
  margin-left: auto;
`;

type NoticeProps = {
  title?: string;
  noticeType: "notice" | "success" | "warning" | "error" | "purple";
  dismissable?: boolean;
  icon?: string;
  children?: ReactNode;
};

function Notice({ title, noticeType, dismissable, icon, children }: NoticeProps) {
  const [dismissed, setDismissed] = useState<boolean>(false);

  const colorMap = {
    notice: "var(--lime-500)",
    success: "var(--green-500)",
    warning: "var(--orange-500)",
    error: "var(--red-600)",
    purple: "var(--purple-600)",
  } as const;

  if (dismissed) {
    return null;
  }

  return (
    <NoticeContainer className="flex rounded border" color={colorMap[noticeType]}>
      <NoticeBorderBar color={colorMap[noticeType]} />
      <div className="gap2 flex flex-col p-4">
        {Boolean(title) && title !== "" ? (
          <NoticeHeading className="m-0 flex items-center gap-2">
            {icon && <Icon icon={icon} className="h-4 w-4 flex-shrink-0" />}
            <span>{title}</span>
          </NoticeHeading>
        ) : null}
        {children}
      </div>
      {dismissable && (
        <DismissButton className="btn px-4 py-5" onClick={() => setDismissed(true)}>
          <Icon className="mx-auto" icon="close" title="Close" />
        </DismissButton>
      )}
    </NoticeContainer>
  );
}

export default Notice;
